import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import './index.css';
import { routeTree } from './routeTree.gen';
import { PostHogProvider } from './layouts/PostHogProvider';
import * as Sentry from '@sentry/react';
import { AppErrorBoundary } from './components/ErrorBoundary';

Sentry.init({
  dsn: 'https://4fca9e01f7235232c2a420639b9ea99c@o4509107306889216.ingest.de.sentry.io/4509107308724304',
});

// Create the router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // This is optional, but recommended for type safety
  defaultErrorComponent: ({ error }: { error: Error }) => (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-red-500">Error</h1>
      <p>{error.message}</p>
    </div>
  ),
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Initialize the router
const rootElement = document.getElementById('root')!;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PostHogProvider>
      <AppErrorBoundary>
        <RouterProvider router={router} />
      </AppErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);
